export default __webpack_public_path__ + "static/media/Twitter.f0b97ad5.png";